import { render, staticRenderFns } from "./propertySystem.vue?vue&type=template&id=8ffa08cc&scoped=true&"
import script from "./propertySystem.vue?vue&type=script&lang=js&"
export * from "./propertySystem.vue?vue&type=script&lang=js&"
import style0 from "./propertySystem.vue?vue&type=style&index=0&id=8ffa08cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffa08cc",
  null
  
)

export default component.exports